module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Size-a3efd1dc30c0142d7d8301b758e3f263.svg";